
import { LabelLayout } from "@/utils/label-layout/label-layout";
import {  Model } from "@/utils/models/model";
import Vue from "vue";
import AppBarcodeSettings from "./BarcodeSettings.vue";
import { Barcode } from "@/utils/label-layout/barcode";

export default Vue.extend({
	data(){
		return {
			toEditBarcodeIndex: -1
		};
	},
	props: {
		layout: {
			type: Object as ()=>LabelLayout,
			required: true
		}
	},
	computed: {
		model():Model{
			return this.layout.getModel();
		}
	},
	methods: {
		addNewBarcode(){
			let code = new Barcode();
			this.layout.Barcodes.push(code);
			this.toEditBarcodeIndex = this.layout.Barcodes.length-1;
		},
		deleteBarcode(i:number){
			this.layout.Barcodes.splice(i,1);
		},
		editBarcode(code:Barcode){
			this.toEditBarcodeIndex = this.layout.Barcodes.indexOf(code);
		}
	},
	components: {
		AppBarcodeSettings
	},
	i18nEx: {
		componentPrefix: "components.layout-editor"
	}
});
